<template>
  <div class="push-binding">
    <h3 class="binding-title">蓝桥运单物通修改推送绑定</h3>
    <van-cell-group>
      <van-field
        label="手机号"
        required
        placeholder="请输入手机号"
        v-model="mobile"
      ></van-field>
      <van-field
        label="验证码"
        required
        placeholder="请输入验证码"
        v-model="code"
      >
        <van-button
          slot="button"
          :disabled="codeDisabled"
          size="small"
          type="primary"
          @click="getCode"
          >获取验证码
        </van-button>
      </van-field>
      <van-field
        label="公司名称"
        required
        placeholder="请输入公司名称"
        v-model="companyName"
      ></van-field>
    </van-cell-group>
    <div class="btn">
      <van-button type="danger" size="normal" @click="submit">确定</van-button>
    </div>
  </div>
</template>

<script>
import { Dialog } from "vant";

export default {
  name: "PushBinding",
  data() {
    return {
      mobile: "",
      companyName: "",
      code: "",
      codeDisabled: false,
      count: "",
      timer: null
    };
  },
  methods: {
    getCode() {
      if (!this.mobile) {
        Dialog.alert({
          message: "请输入手机号!"
        });
        return false;
      }
      this.$axios({
        url: "user/captcha",
        method: "post",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8"
        },
        params: {
          mobile: this.mobile
        }
      }).then(res => {
        if (res.data.code === 200) {
          this.codeDisabled = true;
          let TIME_COUNT = 60;
          let count = TIME_COUNT;
          this.count = "(" + TIME_COUNT + ")";
          this.timer = setInterval(() => {
            if (count > 1 && count <= TIME_COUNT) {
              count--;
              this.count = "(" + TIME_COUNT + ")";
            } else {
              clearInterval(this.timer);
              this.timer = null;
              this.codeDisabled = false;
              this.count = "";
            }
          }, 1000);
        }
      });
    },
    isWxLogin() {
      return (
        window.navigator.userAgent.toLowerCase().indexOf("micromessenger") !==
        -1
      );
    },
    submit() {
      if (this.isWxLogin) {
        let params = {
          params: {
            mobile: this.mobile,
            loginType: 5
          }
        };
        this.$axios.post("weixin/get/openid", params).then(res => {
          if (res.data.code === 200) {
            if (res.data.data) {
              let params = {
                params: {
                  wechatOpenId: res.data.data,
                  mobile: this.mobile,
                  companyName: this.companyName,
                  code: this.code
                }
              };
              this.$axios.post("lanqiao/push/add", params).then(res => {
                if (res.data.code === 200) {
                  this.$router.push("/push/info/" + this.mobile);
                }
              });
            }
          }
        });
      }
    }
  }
};
</script>

<style scoped lang="scss">
.binding-title {
  background-color: #fff;
  font-size: 0.45rem;
  text-align: center;
  padding: 0.425rem 0;
}

.btn {
  padding: 0 0.25rem;
  margin: 0.25rem 0;
  display: flex;
  justify-content: space-around;

  .van-button {
    flex: 1;
    margin: 0 0.25rem;
  }
}
</style>
